"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _Validation = _interopRequireWildcard(require("./Validation"));

var _utils = require("../utils/utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var InputValidation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(InputValidation, _React$Component);

  var _super = _createSuper(InputValidation);

  function InputValidation(props) {
    var _this;

    (0, _classCallCheck2.default)(this, InputValidation);
    _this = _super.call(this, props);
    var _this$props$children$ = _this.props.children.props,
        valid = _this$props$children$.valid,
        value = _this$props$children$.value;
    _this.state = {
      visited: false,
      focused: false,
      valid: valid,
      value: value
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(InputValidation, [{
    key: "handleChange",
    value: function handleChange(value, e) {
      var v = this.validate(value);

      if (v) {
        this.handleValidate(_objectSpread(_objectSpread({}, v), {}, {
          state: v.valid ? _Validation.STATUS.success : _Validation.STATUS.neutral,
          message: v.message,
          event: e
        }));
      } else {
        this.handleValidate({
          message: null,
          state: _Validation.STATUS.neutral,
          event: e
        });
      }

      this.setState({
        value: value,
        valid: v ? v.valid : !this.props.required
      });
      this.props.children.props.onChange && this.props.children.props.onChange(value, e);
    }
  }, {
    key: "handleValidate",
    value: function handleValidate(_ref) {
      var state = _ref.state,
          _ref$message = _ref.message,
          message = _ref$message === void 0 ? null : _ref$message,
          event = _ref.event;

      if (state !== this.state.validationState || message !== this.state.validationMessage) {
        this.setState({
          validationState: state,
          validationMessage: message
        });
        this.props.onValidate({
          state: state,
          message: message,
          event: event
        });
      }
    }
  }, {
    key: "validate",
    value: function validate(value) {
      if ((0, _utils.isBlank)(value)) {
        var required = this.props.required;
        return {
          valid: !required,
          message: required ? 'This field is required' : null
        };
      }

      return this.props.validate(value);
    }
  }, {
    key: "render",
    value: function render() {
      var Child = this.props.children.type;
      return /*#__PURE__*/_react.default.createElement(_Validation.default, (0, _extends2.default)({}, this.props, {
        validationState: this.state.validationState,
        validationMessage: this.state.validationMessage,
        onChange: this.handleChange
      }), /*#__PURE__*/_react.default.createElement(Child, (0, _extends2.default)({}, this.props.children.props, {
        value: this.state.value,
        valid: this.state.valid
      })));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return _objectSpread({}, _Validation.default.propTypes);
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return _objectSpread({}, _Validation.default.defaultProps);
    }
  }]);
  return InputValidation;
}(_react.default.Component);

exports.default = InputValidation;